export const TRASH_QUERY = '#trash'
